import React from 'react';
import './ContactPage.css';

function ContactPage() {
  return (
    <div className="contact-page">
      <div className="contact-header">
        <h2>Contact Information</h2>
        <p className="contact-subtitle">Ready to give your child the best care? Get in touch with us today!</p>
      </div>
      
      <div className="contact-grid">
        <div className="contact-card">
          <div className="contact-icon">📧</div>
          <h3>Email</h3>
          <p className="contact-detail">mahtabshirdelan@gmail.com</p>
          <p className="contact-note">We respond within 24 hours</p>
        </div>
        
        <div className="contact-card">
          <div className="contact-icon">📱</div>
          <h3>Phone</h3>
          <p className="contact-detail">(647) 527-4552</p>
          <p className="contact-note">Call or text anytime</p>
        </div>
        
        <div className="contact-card">
          <div className="contact-icon">📍</div>
          <h3>Location</h3>
          <p className="contact-detail">Bradford West Gwillimbury</p>
          <p className="contact-note">Conveniently located</p>
        </div>
      </div>
      
      <div className="visit-section">
        <h3>Schedule a Visit</h3>
        <p>Parents are welcome to schedule a home visit at any time. Come see our facilities, meet our family, and learn more about our licensed home daycare program.</p>
      </div>
      
      <div className="availability-notice">
        <div className="notice-icon">⚠️</div>
        <div className="notice-content">
          <h4>Limited Availability</h4>
          <p>We currently have only <strong>1 spot available for September</strong>. Contact us as soon as possible to secure your child's place!</p>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;